export const formatPrice = (price) => {
	if (isNaN(price)) return '0';
	return price.toLocaleString('ru-RU');
}; 